import React from 'react';
import MarketingLanding from '../MarketingLanding';

/**
 * App entry for `/` — same marketing page; name kept for compatibility with “landing” routes.
 * Hero video and shell come from `VideoBackground` inside `MarketingLanding`.
 */
function PassFirstDashboard() {
  return <MarketingLanding />;
}

export default PassFirstDashboard;
